import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { PhoneIcon } from 'lucide-react';
import { SITE } from '../constants/site';
export function FloatingCallButton() {
  const [isVisible, setIsVisible] = useState(false);
  const shouldReduceMotion = useReducedMotion();
  useEffect(() => {
    const updateVisibility = () => setIsVisible(window.scrollY > 360);
    updateVisibility();
    window.addEventListener('scroll', updateVisibility, {
      passive: true
    });
    return () => window.removeEventListener('scroll', updateVisibility);
  }, []);
  return <AnimatePresence data-id="element-53" data-mp="3apuy4a5k7ho9">
      {isVisible && <motion.a href={SITE.phoneHref} aria-label={`Call Northface Irrigation at ${SITE.phone}`} initial={shouldReduceMotion ? {
      opacity: 0
    } : {
      opacity: 0,
      x: 96
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={shouldReduceMotion ? {
      opacity: 0
    } : {
      opacity: 0,
      x: 96
    }} transition={{
      duration: 0.24,
      ease: [0.25, 1, 0.5, 1]
    }} className="fixed bottom-5 right-4 z-[60] inline-flex items-center gap-3 rounded-full bg-nfgreen py-3 pl-3 pr-5 text-sm font-extrabold text-white shadow-xl shadow-nfgreen/30 focus:outline-none focus:ring-2 focus:ring-nfgreen focus:ring-offset-2 sm:bottom-6 sm:right-6 sm:pr-6" data-id="element-54" data-mp="3aro6puzqgbyw">
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-nfgreen-dark" data-id="element-55" data-mp="l7fngy97b8jr">
            <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-56" data-mp="3jrfkf9rebq9j" />
          </span>
          <span className="hidden sm:block" data-id="element-57" data-mp="3oph33tkwtnkh">
            <span className="block text-[11px] font-bold uppercase tracking-[0.12em] text-white/75" data-id="element-58" data-mp="3tnsa7wjtljz0">
              Need help now?
            </span>
            Call {SITE.phone}
          </span>
          <span className="sm:hidden" data-id="element-59" data-mp="18xjpx2anl296">Call now</span>
        </motion.a>}
    </AnimatePresence>;
}